import { TitlebarComponent } from '../../../shared/titlebar/titlebar.component';
import { EVENTO } from '../../../shared/common/constant.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RolNewComponent } from './new/rol-new.component';
import { RolEditComponent } from './edit/rol-edit.component';
import { RolViewComponent } from './view/rol-view.component';

@Component({
  //moduleId: module.id,
  selector: 'app-rol',
  templateUrl: 'rol.component.html'
})

export class RolComponent implements OnInit {
  @ViewChild(RolNewComponent) rolNewComponent: RolNewComponent;
  @ViewChild(RolEditComponent) rolEditComponent: RolEditComponent;
  @ViewChild(RolViewComponent) rolViewComponent: RolViewComponent;
  @ViewChild(TitlebarComponent) titlebarComponent: TitlebarComponent;

  evento: EVENTO;
  modulo: string;
  mantenimiento: string;
  titleGeneral: string;
  titleInsertar: string;
  titleEditar: string;
  titleConsultar: string;
  msgEditar: string;
  data: any;
  landingPage: string;

  constructor() {
  }
  ngOnInit() {
    this.landingPage = "/landingAccess";
    this.evento = EVENTO.listar;
    this.modulo = "Seguridad";
    this.mantenimiento = "Rol";
    this.titleGeneral = this.modulo + ": " + this.mantenimiento;
    this.msgEditar = "EDITAR " + this.mantenimiento.toUpperCase();
    this.data = [];
    this.setTitleListar();
  }

  setTitleListar() {
    this.titlebarComponent.iClose = true;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: "" }];
    this.titlebarComponent.eventClose = this.landingPage;
  }

  setTitleInsertar(data: any) {
    this.titleInsertar = "Nuevo Rol";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.listar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleInsertar, event: "" }];
  }

  setTitleEditar(data: any) {
    this.titleEditar = this.mantenimiento + ": " + " (Cod. " + data.rol.ID + ")";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.consultar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleEditar, event: "" }];
  }

  setTitleAsignar(data: any) {
    this.titleEditar = this.mantenimiento + ": " + "  " + data.rol.Name + "";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.listar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleEditar, event: "" }];
  }

  setTitleGuardarAutonomia(data: any) {
    this.titleEditar = this.mantenimiento + ": " + "" + data.rol.Name + "";
    this.titlebarComponent.iCancel = true;
    this.titlebarComponent.eventCancel = EVENTO.asignarAutonomia;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleEditar, event: "" }];
  }

  setTitleConsultar(data: any) {
    this.titleConsultar = this.mantenimiento + ": " + data.rol.Name + " (Cod. " + data.rol.ID + ")";
    this.titlebarComponent.iBack = true;
    this.titlebarComponent.iEdit = true;
    this.titlebarComponent.eventBack = EVENTO.listar;
    this.titlebarComponent.eventEdit = EVENTO.editar;
    this.titlebarComponent.msgEditar = this.msgEditar;
    this.titlebarComponent.msgTitle = [{ title: this.titleGeneral, event: EVENTO.listar }, { title: this.titleConsultar, event: "" }];
  }

  clearTitlebar() {
    this.titlebarComponent.iBack = false;
    this.titlebarComponent.iCancel = false;
    this.titlebarComponent.iClose = false;
    this.titlebarComponent.iEdit = false;
    this.titlebarComponent.msgEditar = "";
    this.titlebarComponent.msgTitle = [];
    this.titlebarComponent.eventBack = EVENTO.listar;
    this.titlebarComponent.eventCancel = EVENTO.listar;
    this.titlebarComponent.eventClose = "";
    this.titlebarComponent.eventEdit = EVENTO.listar;
  }

  changeEvent(evento: any) {
    this.evento = evento.evento;
    this.clearTitlebar();
    if (evento.data)
      this.data = evento.data;
    this.titlebarComponent.data = evento.data;

    switch (this.evento) {
      case EVENTO.listar:
        this.setTitleListar();
        break;
      case EVENTO.crear:
        this.setTitleInsertar(evento.data);
        break;
      case EVENTO.editar:
        this.setTitleEditar(evento.data);
        break;
      case EVENTO.consultar:
        this.setTitleConsultar(evento.data);
        break;
      case EVENTO.asignarAutonomia:
        this.setTitleAsignar(evento.data);
        break;
      case EVENTO.guardarAutonomia:
        this.setTitleGuardarAutonomia(evento.data);
        break;
      case EVENTO.accesoUsuario:
        this.setTitleAsignar(evento.data);
        break;
      case EVENTO.accesoSubmodulo:
        this.setTitleAsignar(evento.data);
        break;
      default:
        break;
    }
  }
}
